<template>
  <el-drawer :title="isedit ? '编辑月卡车辆' : '新增月卡车辆'" :visible.sync="childdialogshow" :show-close="false"
    :destroy-on-close="true" :wrapperClosable="false" direction="rtl" ref="drawer" :size="drawgesize"
    :before-close="cancel">
    <div class="dialogshow">
      <div class="dialoForm-content">
        <el-form class="dialoForm-form" ref="createform" :model="createform" label-width="120px" :rules="rules"
          style="width: 95%">
          <el-form-item label="启用状态：">
            <el-switch style="width: 100%" v-model="createform.EnableMark"></el-switch>
          </el-form-item>
          <el-form-item label="所属路段：" prop="SectionId">
            <el-select style="width: 100%" v-model="createform.SectionId" placeholder="请选择所属路段">
              <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName"
                :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车牌号：" prop="LicencePlate">
            <el-input v-model="createform.LicencePlate" maxlength="10" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="子车牌号：" v-if="ProductId==3">
            <el-input v-model="createform.CLicencePlate" maxlength="10" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="有效期止：" prop="EndDate">
            <el-date-picker style="width: 100%" v-model="createform.EndDate" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="联系人：">
            <el-input maxlength="10" v-model="createform.LinkMan" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：">
            <el-input v-model="createform.LinkTel" maxlength="11" show-word-limit autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input :rows="2" type="textarea" v-model="createform.Remark" maxlength="200" show-word-limit
              autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialoForm-footer">
        <el-button @click="cancel" style="width: 100px">取 消</el-button>
        <el-button style="width: 100px" type="primary" @click="save">保 存</el-button>
      </div>
    </div>
  </el-drawer>
</template>
<script>
import { create, edit } from "@/api/monthcardcar";
export default {
  name: "addmouthcard",
  props: {
    isedit: {
      required: true,
      type: Boolean,
    },
    dialogshow: {
      required: true,
      type: Boolean,
    },
    editform: {
      required: true,
      type: Object,
    },
    sectionlist: {
      required: true,
      type: Array,
    },
  },
  computed: {
    childdialogshow: {
      get() {
        return this.dialogshow;
      },
      set(val) {
        this.$emit("update:dialogshow", val);
      },
    },
  },
  data() {
    return {
      drawgesize: 680,
      activeName: "1",
      createform: {
        Id: 0,
        LicencePlate: "",
        LinkMan: "",
        LinkTel: "",
        CreateTime: "2023-02-15T03:00:07.702Z",
        CreateUserId: 0,
        ModiftyTime: "2023-02-15T03:00:07.702Z",
        ModiftyUserId: 0,
        Remark: "",
        SectionId: "",
        EnableMark: true,
        BeginDate: "2023-02-15T03:00:07.702Z",
        EndDate: "",
      },
      ProductId:1,
      rules: {
        LicencePlate: [
          { required: true, message: "车牌号不能为空", trigger: "blur" },
          {
            max: 12,
            message: "规则名称长度不超过12个字，请重新输入",
            trigger: "blur",
          },
        ],
        SectionId: [
          { required: true, message: "请选择所属路段", trigger: "change" },
        ],
        EndDate: [
          { required: true, message: "请选择月卡有效期", trigger: "change" },
        ],
      },
    };
  },
  created() {
    var size = this.getViewWidth();
    if (size === 540) {
      this.drawgesize = 600;
    } else {
      this.drawgesize = size;
    }
    if (this.isedit) {
      this.createform = this.editform;
    }
    this.ProductId=window.localStorage.ProductId;
  },
  methods: {
    addrow(index) {
      this.createform.RuleDetailJson.splice(index + 1, 0, {
        month: "",
        fee: 0,
      });
    },
    removerow(index) {
      this.createform.RuleDetailJson.splice(index, 1);
    },
    save() {
      let vm = this;
      vm.$refs.createform.validate((valid) => {
        if (valid) {
          let postform = JSON.parse(JSON.stringify(vm.createform));
          postform.RuleDetailJson = JSON.stringify(postform.RuleDetailJson);
          if (!vm.isedit) {
            create(postform).then((res) => {
              vm.$message({
                message: "新增成功！",
                type: "success",
              });
              vm.childdialogshow = false;
              vm.$emit("savecomplete");
              vm.$bus.$emit("addrule", "addrule");
            });
          } else {
            edit(postform).then((res) => {
              vm.$message({
                message: "保存成功！",
                type: "success",
              });
              vm.childdialogshow = false;
              vm.$emit("savecomplete");
              vm.$bus.$emit("addrule", "addrule");
            });
          }
        }
      });
    },
    cancel() {
      this.$emit("cancelcomplete");
    },
  },
};
</script>